/** True for iPhone / iPod touch / iPadOS Safari & Chrome (WKWebView). */
export const getIsIosTouchDevice = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false
  }

  const { userAgent, maxTouchPoints, platform } = navigator
  const isAppleMobileUa = /iPad|iPhone|iPod/i.test(userAgent)
  const isIpadOsDesktopUa =
    platform === 'MacIntel' &&
    typeof maxTouchPoints === 'number' &&
    maxTouchPoints > 1

  return isAppleMobileUa || isIpadOsDesktopUa
}
